<div class="container">
  @if (_currentData.userdetails!=undefined && _currentData.userdetails.display_name!=undefined && !isPopup && !utilService.isMobile()) {
    <div class="profile-header" (click)="navigationBack()"
      >
      <div>
        <img src="assets/images/grid-back.png" />
      </div>
      <div class="profile-name text-capitalize">
        {{_currentData.userdetails.display_name}}'s Profile
      </div>
    </div>
  }
  @if (_currentData.userdetails!=undefined && _currentData.cards!=undefined) {
    <!-- Doctor Profile Header -->
    @for (card of _currentData.cards; track card) {
      <div class="profile-card">
        <div class="profile-header">
          @if (card.type=='profile') {
            <div class="profile-avatar new">
              <div>
                @if (card.profile_key != undefined && _currentData.userdetails[card.profile_key]) {
                  <img [src]="profile_path ? (profile_path | secure | async) : './assets/images/user-image.png'"
                    (error)="$event.target.src='./assets/images/user-image.png'" loading="lazy" sizes="145px" />
                } @else {
                  @if (!card.image_src) {
                    <img src="./assets/images/user-image.png">
                  }
                  @if (card.image_src) {
                    <img [src]="card.image_src">
                  }
                }
              </div>
            </div>
          }
          <!-- Doctor Profile Header Details-->
          @if (card.heading && card.sub_heading) {
            <div class="profile-info">
              @if (_currentData.userdetails[card.heading]) {
                <h1 class="doctor-name">
                  {{_currentData.userdetails[card.heading]}}
                </h1>
              }
              @if (card.heading && card.sub_heading) {
                <div class="doctor-profile-details">
                  @if (getDoctorExperince(_currentData?.userdetails); as doctorInfo) {
                    @if (doctorInfo) {
                      <i [class]="card.sub_heading.icon"></i>
                    }
                    {{ doctorInfo }}
                  }
                </div>
              }
              @for (f of card.fields; track f) {
                @if ((_currentData.userdetails | mapvalue: f)) {
                  @if (f.type != 'currency') {
                    <div class="doctor-profile-details">
                      <i [class]="f.icon"></i>
                      {{ _currentData.userdetails | mapvalue: f }}
                    </div>
                  }
                  @if (f.type == 'currency') {
                    <div class="doctor-profile-details">
                      <i [class]="f.icon"></i>
                      {{ _currentData.userdetails | mapvalue: f }} {{ _currentData.userdetails.facility_id |
                      BPcurrency }}
                    </div>
                  }
                }
              }
            </div>
          }
        </div>
        <!-- Weekly Schedule -->
        @if (card.type=='specialArray') {
          <div class="schedule-card">
            <h2 class="card-title">
              <i class="fa fa-calendar" aria-hidden="true" style="color: #5cbaf1;"></i>
              {{'field.label.week_schedule' | translate | async}}
            </h2>
            @for (f of card.fields; track f) {
              @if (f.heading!=undefined && f.type == 'scheduleTime' && this.calculateValue(_currentData.userdetails,f.format,f.type)!='Invalid Date') {
                <div class="schedule-grid"
                  >
                  <div>
                    <h3 class="day-name">{{f.heading | translate | async}}</h3>
                    @for (r of this.calculateValue(_currentData.userdetails,f.format,f.type); track r) {
                      <div class="time-slot">{{r}}</div>
                    }
                  </div>
                </div>
              }
            }
          </div>
        }
        <!-- Other Details -->
        @if (card.cardBottomDetails) {
          <div class="details-card">
            <h2 class="card-title">
              <i class="fa fa-info-circle" aria-hidden="true" style="color: #5cbaf1;"></i>
              {{'Other Details' | translate | async}}
            </h2>
            @for (f of card.fields; track f) {
              @if (f.heading!=undefined && f.type != 'scheduleTime') {
                <div class="schedule-grid">
                  @if (f.about_doctor) {
                    <div>
                      <h3>{{f.heading | translate | async}}</h3>
                      <p class="about-text">
                        {{ _currentData.userdetails | mapvalue: f }}
                      </p>
                    </div>
                  }
                  @if (!f.about_doctor) {
                    <div class="info-grid">
                      <div class="info-item">
                        <h4 class="info-label">{{f.heading | translate | async}}</h4>
                        <p class="info-value">{{ _currentData.userdetails | mapvalue: f }}</p>
                      </div>
                    </div>
                  }
                  @if (f.type == 'file' && _currentData.userdetails[f.name] != undefined) {
                    <dhs-file-uploader
                      [id]="f.name" [multiple]="f.multiple" [formatsAllowed]="'.jpg,.jpeg,.png,.Png'"
                      [maxSize]="15" [resource]="f.resource" [formAction]="'VIEW'"
                      [value]="_currentData.userdetails[f.name]">
                    </dhs-file-uploader>
                  }
                  @if (f.type == 'compositefile' && _currentData.userdetails[f.name] != undefined) {
                    <dhs-file-uploader
                      [id]="calculateValue(_currentData.userdetails,f.format)" [multiple]="f.multiple"
                      [formatsAllowed]="'.jpg,.jpeg,.png,.Png'" [maxSize]="15" [resource]="f.resource"
                      [formAction]="'VIEW'" [value]="calculateValue(_currentData.userdetails,f.format)">
                    </dhs-file-uploader>
                  }
                  <!-- <p *ngIf="f.type == 'compositefile'">{{calculateValue(_currentData.userdetails,f.format)|json}}</p> -->
                  @if (f.type == 'compositeType' && this._currentData.userdetails.extra_data[f.name] ) {
                    <div>
                      @if (f.type == 'compositeType') {
                        <img height="100" width="200"
                          [src]="getSignature(f.name,f.resource) | secure | async">
                      }
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
        <!-- About Section -->
        @if (card.type=='specialArray') {
          <div class="schedule-card">
            <h2 class="card-title">
              <i class="fa fa-adn" aria-hidden="true" style="color: #5cbaf1;"></i>
              {{'field.label.about_doctor' | translate | async}}
            </h2>
            @for (f of card.fields; track f) {
              @if (f.about_doctor == 'topFirst') {
                <div style="word-break: break-word;font-size: 15px; line-height: 15px;"
                  [innerHTML]="_currentData.userdetails | mapvalue: f">
                </div>
              }
            }
          </div>
        }
      </div>
    }
  }
</div>